import ExternalLink from 'components/common/ExternalLink'
import TestIds from 'util/TestIds'

const AppBadges = (): JSX.Element => {
  return (
    <div className="z-[1] mt-6 flex items-center justify-center gap-6 2xl:mr-[98px]">
      <ExternalLink
        data-testid={TestIds.login.button.downloadApple}
        href="https://apps.apple.com/us/app/timelycare-higher-ed/id1502432982?itsct=apps_box_badge&amp;itscg=30200"
      >
        <img className="h-10 w-32 xl:h-14 xl:w-36" alt="Download on the App Store" src="/appstore-badge.svg" />
      </ExternalLink>
      <ExternalLink
        data-testid={TestIds.login.button.downloadGoogle}
        href="https://play.google.com/store/apps/details?id=md.timely.member&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
      >
        <img className="h-10 w-32 xl:h-14 xl:w-36" alt="Get it on Google Play" src="/google-play-badge.svg" />
      </ExternalLink>
    </div>
  )
}

export default AppBadges
